/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigScopeDetailsBaseForServiceAccount extends models.LockConfigScopeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("LockConfigDetailsBaseForServiceAccount");
    }

    getFixupPrototypeFunction() { return LockConfigScopeDetailsBaseForServiceAccount.fixupPrototype; }

    static newInstance(model: Partial<LockConfigScopeDetailsBaseForServiceAccount>): LockConfigScopeDetailsBaseForServiceAccount {
        let obj = Object.assign(new LockConfigScopeDetailsBaseForServiceAccount(), model);
        LockConfigScopeDetailsBaseForServiceAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigScopeDetailsBaseForServiceAccount>): LockConfigScopeDetailsBaseForServiceAccount {
        if (!model) return null;
        return LockConfigScopeDetailsBaseForServiceAccount.newInstance(<LockConfigScopeDetailsBaseForServiceAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigScopeDetailsBaseForServiceAccount) {
        if (!obj) return;

        models.LockConfigScopeDetailsBaseForServiceAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigScopeDetailsBaseForServiceAccount): boolean {
        if (models.LockConfigScopeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LockConfigScopeDetailsBaseForServiceAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Get resource filters of cloud account
     */
    resources: Array<string>;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

    /**
     * Enable Account/Subscription/Project level Lock
     */
    account_scope_lock: boolean;

}
